import { createContext, type ReactNode, useContext, useState } from "react";

interface HeaderContextType {
  hasScreenHeaderWithBack: boolean;
  setHasScreenHeaderWithBack: (value: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [hasScreenHeaderWithBack, setHasScreenHeaderWithBack] = useState(false);

  return (
    <HeaderContext.Provider
      value={{ hasScreenHeaderWithBack, setHasScreenHeaderWithBack }}
    >
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderContext() {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error("useHeaderContext must be used within a HeaderProvider");
  }
  return context;
}
